import { FC, TextareaHTMLAttributes, useEffect, useRef } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export const Textarea: FC<TextareaHTMLAttributes<HTMLTextAreaElement>> = ({
  value,
  onChange,
  ...props
}) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  const adjustHeight = () => {
    if (!ref.current) return;
    ref.current.style.height = 'auto';
    ref.current.style.height = `${ref.current.scrollHeight}px`;
  };

  useEffect(() => {
    adjustHeight();
  }, [value]);

  return (
    <TextareaStyled
      {...props}
      value={value}
      ref={ref}
      onChange={(e) => {
        adjustHeight();
        onChange?.(e);
      }}
    />
  );
};

const TextareaStyled = styled.textarea`
  border: 1px solid ${COLORS.systemDark100};
  border-radius: 8px;
  width: 100%;
  padding: 8px 12px;
  font-size: inherit;
  outline: none;
  transition: border-color 0.2s;

  &::placeholder {
    color: ${COLORS.systemDark100};
  }

  &:active,
  &:focus {
    border-color: ${COLORS.systemDark300};
  }

  &.error {
    border-color: ${COLORS.systemFlame200};
  }
`;
